import type { Currency } from "client/api-v2";

// Pinned to en-US so the output matches the designs on every machine, regardless of the
// viewer's browser locale (en-AU renders USD as "USD 1,000.00" rather than "$1,000.00").
export const formatMoney = (amount: number, currency: Currency): string =>
  new Intl.NumberFormat("en-US", { style: "currency", currency }).format(amount);
